import React, { useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Box, CircularProgress } from '@barracuda-internal/bds-core';
import WrapperContainer from './comp/wrapper/WrapperContainer';
import { DashboardContainer } from './comp/dashboard';
import ScansPage from './comp/scans/ScansPage';
import { ApiKeysContainer } from './comp/apiKeys';
import MembersContainer from './comp/settings/MembersContainer';
import { LoginContainer } from './comp/login';
import AccountDisabledPage from './comp/common/AccountDisabledPage';
import ComingSoonPage from './comp/common/ComingSoonPage';
import RoleGuard from 'common/components/RoleGuard';
import { actions as authActions } from './comp/login/authReducer';

const PrivateRoute = ({ component: Component, isAuthenticated, isLoading, ...rest }) => {
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

const AuthenticatedApp = () => (
  <WrapperContainer>
    <Switch>
      <Route exact path="/account-disabled" component={AccountDisabledPage} />

      {/* Account-scoped views */}
      <Route exact path="/" component={DashboardContainer} />
      <Route exact path="/scans" component={ScansPage} />
      <Route
        path="/scans/:correlationId"
        render={({ match }) => (
          <Redirect to={`/scans?open=${match.params.correlationId}`} />
        )}
      />
      <Route exact path="/api-keys">
        <RoleGuard requires="account_admin">
          <ApiKeysContainer />
        </RoleGuard>
      </Route>
      <Route exact path="/settings/members">
        <RoleGuard requires={["account_admin", "account_member", "account_viewer"]}>
          <MembersContainer />
        </RoleGuard>
      </Route>
      <Route exact path="/settings">
        <ComingSoonPage
          title="Settings"
          description="Account-wide preferences and tunable options. We'll add things here as they come online."
        />
      </Route>

      <Redirect to="/" />
    </Switch>
  </WrapperContainer>
);

const GuardianApp = ({ isAuthenticated, isLoading, checkSession }) => {
  useEffect(() => {
    checkSession();
  }, [checkSession]);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Switch>
      <Route path="/login" component={LoginContainer} />
      <PrivateRoute
        path="/"
        component={AuthenticatedApp}
        isAuthenticated={isAuthenticated}
        isLoading={isLoading}
      />
    </Switch>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.guardian.auth.isAuthenticated,
  isLoading: state.guardian.auth.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  checkSession: () => dispatch(authActions.checkSession()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GuardianApp);
